// src/routes/pdid.routes.tsx
// Fixed: uses correct import path for createProtectedRoute
import { lazy } from 'react';
import { createProtectedRoute } from '@/routes/core/createProtectedRoute';
import type { AppRoute } from '@/routes/core/types';
const JourneyTimelinePage = lazy(() => import('@/pages/journey/JourneyTimelinePage'));

const PDIDDashboard = lazy(() => import('@/pages/pdid/PDIDDashboard'));
const JourneyOSDashboard = lazy(() => import('@/pages/journey/JourneyOSDashboard'));
// Matches this file's own lazy-loading convention -- was an eager, non-lazy
// import before this fix, bundling JourneyLaunchPage's code into whatever
// chunk this routes file lands in instead of code-splitting it like every
// other page here.
const JourneyLaunchPage = lazy(() => import('@/pages/journey/JourneyLaunchPage'));
const InCountryLaunchWizard = lazy(() => import('@/pages/journey/InCountryLaunchWizard'));
const VisaguideEntrance = lazy(() => import('@/pages/journey/VisaguideEntrance'));
const UkCosCompanion = lazy(() => import('@/pages/journey/UkCosCompanion'));
const CompanionResults = lazy(() => import('@/pages/journey/CompanionResults'));
const CourseCenterV3 = lazy(() => import('@/pages/course/CourseCenterV3'));
const CourseDelivery = lazy(() => import('@/pages/course/CourseDelivery'));
const UnifiedWrapper = lazy(() => import('@/pages/course/UnifiedWrapper'));

export const pdidRoutes: AppRoute[] = [
  {
    id: 'pdid.dashboard',
    domain: 'pdid',
    path: '/pdid',
    element: createProtectedRoute(<PDIDDashboard />, {
      protected: true,
      meta: { title: 'PDID Dashboard — Your Identity' }
    })
  },
  {
    id: 'journeyos.entrance',
    domain: 'journeyos',
    path: '/journey-entrance',
    element: createProtectedRoute(<VisaguideEntrance />, {
      protected: true,
      meta: { title: 'AssessmentOS — Choose destination (UK · Canada · Germany · Australia · New Zealand · Ireland)' }
    })
  },
  {
    id: 'journeyos.launch',
    domain: 'journeyos',
    path: '/journey-launch',
    element: createProtectedRoute(<JourneyLaunchPage />, {
      protected: true,
      meta: { title: 'Journey Launch Wizard' }
    })
  },
  {
    id: 'journeyos.launch_inside',
    domain: 'journeyos',
    path: '/journey-launch-inside',
    element: createProtectedRoute(<InCountryLaunchWizard />, {
      protected: true,
      meta: { title: 'Already in UK — Journey Launch Wizard' }
    })
  },
  {
    id: 'journeyos.uk_cos_companion',
    domain: 'journeyos',
    path: '/uk-cos-companion',
    element: createProtectedRoute(<UkCosCompanion />, {
      protected: true,
      meta: { title: 'UK COS Companion — Deep Sky Blueprint' }
    })
  },
  {
    id: 'journeyos.companion_results',
    domain: 'journeyos',
    path: '/companion-results',
    element: createProtectedRoute(<CompanionResults />, {
      protected: true,
      meta: { title: 'Companion Blueprints — Inside UK' }
    })
  },
  {
    id: 'journeyos.dashboard',
    domain: 'journeyos',
    path: '/journey',
    element: createProtectedRoute(<JourneyOSDashboard />, {
      protected: true,
      meta: { title: 'JourneyOS — Your Migration Navigator' }
    })
  }
  ,{
    id: 'journeyos.timeline',
    domain: 'journeyos',
    path: '/journey-timeline',
    element: createProtectedRoute(<JourneyTimelinePage />, {
      protected: true,
      meta: { title: 'Your Migration Journey Timeline' }
    })
  },
  {
    id: 'journeyos.course_center',
    domain: 'journeyos',
    path: '/course-center',
    element: createProtectedRoute(<CourseCenterV3 />, {
      protected: true,
      meta: { title: 'Course Center v3 — Visaguide Learning Hub' },
    }),
  },
  {
    id: 'journeyos.course_delivery',
    domain: 'journeyos',
    path: '/course-center/learn/:courseId',
    element: createProtectedRoute(<CourseDelivery />, {
      protected: true,
      meta: { title: 'Course Delivery — Inside Visaguide' },
    }),
  },
  {
    id: 'journeyos.os_wrapper',
    domain: 'journeyos',
    path: '/os-wrapper',
    element: createProtectedRoute(<UnifiedWrapper />, {
      protected: true,
      meta: { title: 'Unified OS Wrapper — Host All Tools' },
    }),
  },
];
